import { PRODUCT_STOCK_CLIENT_SERVICE_URL } from 'product/constants/constants'
import type { PageParams } from 'types/pageParams'
import { env } from 'utils/envManager'

import type { Product } from '../../../types'
import type { Stock } from '../../../types/Stock'

interface GetClientProductStock {
	productId: Product['id']
	country: PageParams['country']
	language: PageParams['language']
	enabled?: boolean
}

export const getClientProductStock = async (
	params: GetClientProductStock
): Promise<Stock | null> => {
	const { productId, language, country } = params

	const baseUrl = `${PRODUCT_STOCK_CLIENT_SERVICE_URL}${productId}`

	const url = new URL(baseUrl, env.NEXT_PUBLIC_SITE_BASE_URL)

	const searchParams = new URLSearchParams({
		countryIso: country.toUpperCase(),
		channelId: env.NEXT_PUBLIC_CHANNEL,
		language,
	})

	url.search = searchParams.toString()

	const response = await fetch(url.href, {
		next: {
			revalidate: 0,
		},
	})

	if (response.ok) {
		return response.json()
	}

	return null
}
